<template>
  <div class="handover-component">
    <IslandBadge type="humanhandover" :draggable="false"></IslandBadge>
    <div class="component-contents">Pause Bot</div>
  </div>
</template>

<script lang="ts" setup>
import { StateViewModel } from '@/features/bots/models/designer';
import IslandBadge from './IslandBadge.vue';
import { PropType, ref, watch } from 'vue';

const props = defineProps({
  value: {
    type: Object as PropType<StateViewModel>,
    required: true,
  },
});

const state = ref<StateViewModel>({
  id: '',
  component: 'HumanHandover',
});

watch(
  () => props.value,
  (value) => (state.value = value),
  { immediate: true },
);
</script>

<style scoped lang="scss">
.handover-component {
  display: flex;
  flex: 1;
  border-radius: 5px;
}

.component-contents {
  padding-right: 2em;
}
</style>
